document.querySelectorAll<HTMLTableElement>('table:not([data-ignore-table])').forEach(table => {
  const headers: string[] = [];

  const hasThead = table.querySelector('thead');

  if (hasThead) {
    // Get all headers from the thead
    table.querySelectorAll<HTMLTableCellElement>('thead tr th').forEach(th => {
      headers.push(th.innerText);
    });
  } else {
    // Check if the first row in tbody has th elements
    const firstRow = table.querySelector<HTMLTableRowElement>('tbody tr:first-child');

    // If first row contains only th, it's assumed to be wrongly set by the author
    if (firstRow && !firstRow.querySelector('td')) {
      firstRow.querySelectorAll<HTMLTableCellElement>('th').forEach(th => {
        headers.push(th.innerText);
      });

      firstRow.classList.add('desktop-only');
    }
  }

  if (headers.length > 0) {
    table.classList.add('responsive-table');
  }

  // Set data label for each row's cells
  table.querySelectorAll<HTMLTableRowElement>('tbody tr').forEach(row => {
    row.querySelectorAll<HTMLTableCellElement>('td').forEach((cell, index) => {
      cell.setAttribute('data-label', headers[index] ?? '');
    });
  });
});
